import { createSlice } from "@reduxjs/toolkit";

const aiChatBotSlice = createSlice({
  name: "aiChatBot",
  initialState: {
    loading: false,
    loadingChat: false,
    error: false,
    chatbotConversationOfUser: [],
    chatbotConversationsHistory: [],
    chatbotConversation: [],
    totalPages: 0,
    currentPage: 0,
    size: 10,
    hasMore: false,
    isNewChat: true,
    isTyping: false,
    loadMore: false,
    sessionId: null
  },
  reducers: {
    getAllChatbotConversationOfUserRequest: (state) => {
      state.loading = true;
    },
    getAllChatbotConversationOfUserSuccess: (state, action) => {
      state.loading = false;
      state.chatbotConversationOfUser = action.payload;
    },
    getAllChatbotConversationOfUserFailure: (state) => {
      state.loading = false;
    },

    getChatbotConversationsHistoryRequest: (state, action) => {
      const { page, sessionId } = action.payload;

      if (page === 0) {
        state.loadingChat = true;
        state.chatbotConversationsHistory = [];
        state.sessionId = sessionId;
      }
      state.chatbotConversation = [];
      state.currentPage = page;
      state.loadMore = state.hasMore;
    },
    getChatbotConversationsHistorySuccess: (state, action) => {
      state.loadingChat = false;
      state.error = null;
      state.isNewChat = false;

      const { items, totalPages } = action.payload;

      state.totalPages = totalPages;

      const existing = state.chatbotConversationsHistory || [];

      const newItems = items.filter(
        (item) => !existing.some((x) => x.id === item.id)
      );

      state.chatbotConversationsHistory = [...existing, ...newItems];
      state.loadMore = false;
      state.hasMore = state.currentPage + 1 < totalPages;
    },
    getChatbotConversationsHistoryFailure: (state, action) => {
      state.loadingChat = false;
      state.error = action.payload;
    },
    chatStreamRequest: (state) => {
      state.loading = true;
      state.isNewChat = false;
      state.chatbotConversation = [];
    },
    chatStreamSuccess: (state, action) => {
      state.loading = !action.payload.is_done;
      state.chatbotConversation = action.payload;
    },
    chatStreamFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    startNewChat: (state) => {
      state.error = null;
      state.isNewChat = true;
      state.chatbotConversation = [];
      state.chatbotConversationsHistory = [];
      state.isTyping = false;
      state.sessionId = null;
    },
    setSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
    setTyping: (state, action) => {
      state.isTyping = action.payload;
    },
    resetAiChatBot: (state) => {
      state.error = null;
      state.isNewChat = true;
      state.chatbotConversation = [];
      state.chatbotConversationsHistory = [];
      state.chatbotConversationOfUser = [];
      state.isTyping = false;
      state.sessionId = null;
    }
  }
});

export const {
  getAllChatbotConversationOfUserRequest,
  getAllChatbotConversationOfUserSuccess,
  getAllChatbotConversationOfUserFailure,
  getChatbotConversationsHistoryRequest,
  getChatbotConversationsHistorySuccess,
  getChatbotConversationsHistoryFailure,
  chatStreamRequest,
  chatStreamSuccess,
  chatStreamFailure,
  startNewChat,
  setTyping,
  setSessionId,
  resetAiChatBot
} = aiChatBotSlice.actions;
export default aiChatBotSlice.reducer;
